import { Helmet } from 'react-helmet-async'
import { Link } from 'react-router-dom'
import FrontDoorCalc from '../components/calculators/FrontDoorCalc'
import { Breadcrumbs } from '../components/shared/Breadcrumbs'
import { generateBreadcrumbList } from '../utils/schemaHelpers'

export default function FrontDoorPage() {
  return (
    <>
      <Helmet>
        <title>Azure Front Door Cost Calculator UK | AzureCalc.uk</title>
        <meta name="description" content="Estimate Azure Front Door Classic, Standard, and Premium costs in GBP for UK South. Compare requests, transfer, WAF, and DDoS costs with migration warnings." />
        <link rel="canonical" href="https://www.azure-calc.co.uk/front-door" />
        <meta property="og:title" content="Azure Front Door Cost Calculator UK" />
        <meta property="og:description" content="Compare Front Door Classic vs Standard vs Premium pricing in GBP with WAF, transfer, and DDoS assumptions for UK South." />
        <meta property="og:url" content="https://www.azure-calc.co.uk/front-door" />
        <meta property="og:image" content="https://www.azure-calc.co.uk/og/azure-calc-og.png" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <script type="application/ld+json">{JSON.stringify(generateBreadcrumbList([
          { name: 'Home', url: '/', position: 1 },
          { name: 'Azure Front Door Calculator', url: '/front-door', position: 2 },
        ]))}</script>
        <script type="application/ld+json">{JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'WebApplication',
          name: 'Azure Front Door Cost Calculator',
          description: 'Independent Azure Front Door pricing calculator for UK South — compare Classic, Standard, and Premium with transfer, WAF, and DDoS assumptions.',
          url: 'https://www.azure-calc.co.uk/front-door',
          applicationCategory: 'FinanceApplication',
          operatingSystem: 'Web',
          offers: { '@type': 'Offer', price: '0', priceCurrency: 'GBP' },
        })}</script>
      </Helmet>

      <div className="px-6 py-6 w-full">
        <div className="pb-6 mb-8" style={{ borderBottom: '1px solid var(--outline-variant)' }}>
          <Breadcrumbs />
          <h1 className="text-2xl font-bold mb-2" style={{ color: 'var(--text-primary)' }}>
            Azure Front Door Cost Calculator
          </h1>
          <p className="text-sm" style={{ color: 'var(--text-tertiary)' }}>
            UK South pricing · Classic vs Standard vs Premium · Requests · Transfer · WAF · DDoS
          </p>
        </div>

        <FrontDoorCalc />

        <div className="mt-12 pt-8" style={{ borderTop: '1px solid var(--outline-variant)' }}>
          <h2 className="text-[13px] font-bold uppercase tracking-widest mb-4" style={{ color: 'var(--text-tertiary)' }}>Related guides</h2>
          <Link
            to="/guides/azure-front-door-pricing-uk"
            className="flex items-center gap-3 p-4 rounded transition-colors group"
            style={{ backgroundColor: 'var(--surface-container)', border: '1px solid var(--outline-variant)' }}
          >
            <span className="material-symbols-outlined text-[#0078d4] text-[20px]" style={{ fontVariationSettings: "'FILL' 1" }}>menu_book</span>
            <div>
              <p className="text-[14px] font-semibold group-hover:text-[#0078d4] transition-colors" style={{ color: 'var(--text-secondary)' }}>Azure Front Door Pricing Guide UK</p>
              <p className="text-[12px]" style={{ color: 'var(--text-tertiary)' }}>Classic retirement, Premium migration trap, and what actually drives Front Door cost</p>
            </div>
            <span className="material-symbols-outlined text-[#0078d4] text-[16px] ml-auto">arrow_forward</span>
          </Link>
        </div>
      </div>
    </>
  )
}
